import { ViewMode } from '../constants';
export var isPreview = function (viewMode) {
    return viewMode === ViewMode.PREVIEW;
};
